var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card"},[_c('div',[_c('div',{staticClass:"info-card__top"},[_c('h3',{staticClass:"info-card__name"},[_vm._v(_vm._s(_vm.faculty.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }